import { gql } from 'apollo-angular'

import { ORGANIZATION_FIELDS } from '../../fragments/organization.fragment'

export const GET_ORGANIZATION_FOR_RESELLER = gql`
  query OrganizationForReseller($where: Organization_where) {
    Organizations(where: $where, limit: -1, sort: "name") {
      docs {
        ...OrganizationFields
        billingAdmins {
          docs {
            id
            first_name
            last_name
            name
            email
          }
        }
      }
    }
  }
  ${ORGANIZATION_FIELDS}
`
